import * as React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

function PhoneIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 41 45">
      <path
        d="M39.2038 34.3391L33.1204 27.6954C32.4971 27.0147 31.5604 26.5887 30.6271 26.5887C29.6138 26.5887 28.6771 27.0147 27.9771 27.7791L26.2604 29.6539C25.8704 30.0798 25.4038 30.2509 24.8571 30.2509C24.5438 30.2509 24.1538 30.1672 23.8438 29.9961C21.1938 28.2924 19.4004 26.8436 17.6838 24.9724C15.7338 22.8428 14.4104 20.8006 13.0838 18.2451C12.6171 17.3932 12.7704 16.3703 13.3938 15.6895L15.1104 13.8148C16.5138 12.2822 16.5938 9.72664 15.1871 8.19405L9.10375 1.55405C8.48042 0.873309 7.54375 0.447388 6.60709 0.447388C5.59375 0.447388 4.65709 0.873309 3.95709 1.64142C1.93042 3.85476 0.527086 5.64217 0.137086 9.30436C-0.719581 16.7125 2.39709 23.4398 10.6638 32.5516C14.8738 37.1494 19.2404 40.3857 23.6071 42.3442C27.1938 43.8768 29.8438 44.1316 31.1704 44.1316H31.9504C35.3038 43.7057 36.7838 42.2568 38.9671 39.9598C40.5271 38.4272 40.6038 35.8716 39.2004 34.3391H39.2038Z"
      />
    </SvgIcon>
  );
}

export { PhoneIcon };
